import { isJsonEqual } from "../utils/Json";
import Fido from './Fido';

export const useFilterHandler = () => {
	return (option, name, selectAll, reset, array, defaultValue, setter, filteredSelectAll) => {
		let defaults = defaultValue,
			// deep copy array because changing attributes on objects in array affects original array
			newArray = JSON.parse(JSON.stringify(array));

		if (name == 'category' && option) {
			newArray.map(x => x.selected = false);
		} else if (name == 'category' && !option) {
			newArray.map(x => x.selected = true);
		}
		if (!reset) {
			newArray.map(opt => {
				if (selectAll != null) {
					opt.selected = selectAll;
				} else if ((option && opt.id === option.id) || (filteredSelectAll === true && !opt.hidden)) {
					opt.selected = !opt.selected;
				}

				return opt;
			});

			if (!isJsonEqual(newArray, array)) {
				setter(newArray);
			}
		} else {
			if (defaults == null) {
				defaults = newArray;
				defaults.forEach(opt => opt.selected = true);
			}
			setter(defaults);
		}

		return {
			reset: reset,
			defaults: defaults,
			newArray: newArray,
			selectAll: selectAll,
			filteredSelectAll: filteredSelectAll
		};
	};
};

export const useCurrentlySticky = (authenticatedUser, stickyLocalStorageKey) => {
	let obj = localStorage.getItem(stickyLocalStorageKey);
	return obj !== null && JSON.parse(obj)[authenticatedUser.id];
};

export const setStickyFilter = (authenticatedUser, filters, localStorageKey) => {
	let obj = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
	obj[authenticatedUser.id] = filters;
	localStorage.setItem(localStorageKey, JSON.stringify(obj));
}

export const useStickyFilterOptions = (hasSticky, authenticatedUser, localStorageKey, allOpts) => {
	let opts,
		localStorageSelections,
		localStorageObj = localStorage.getItem(localStorageKey);

	if (hasSticky && localStorageObj !== null) {
		localStorageSelections = JSON.parse(localStorageObj)[authenticatedUser.id];
	}

	opts = allOpts.map(opt => {
		opt.selected = localStorageSelections ? localStorageSelections.findIndex(item => opt.id === item.id) !== -1 : true;
		return opt;
	});

	return opts;
};


export const useStickyFilterHandler = () => {
	return (authenticatedUser, opts, localStorageKey, isSticky) => {
		let length,
			filters,
			obj = JSON.parse(localStorage.getItem(localStorageKey) || "{}");

		filters = opts.filter(accnt => accnt.selected);
		obj[authenticatedUser.id] = filters;
		length = obj[authenticatedUser.id].length;

		if (isSticky && length > 0) {
			localStorage.setItem(localStorageKey, JSON.stringify(obj));
			persistFilter(authenticatedUser, filters);
		} else if (isSticky === false) {
			delete obj[authenticatedUser.id];

			if (Object.keys(obj).length === 0) {
				localStorage.removeItem(localStorageKey);
			} else {
				localStorage.setItem(localStorageKey, JSON.stringify(obj));
			}

			deletePersistentFilter(authenticatedUser);
		}
	};
};

const persistFilter = (authenticatedUser, filterObj) => {
	let fido = new Fido();
	fido.fetch(`/users/${authenticatedUser.id}/filters`, {
		method: "PUT",
		body: JSON.stringify({filters: filterObj})
	});
};

const deletePersistentFilter = (authenticatedUser) => {
	let fido = new Fido();
	fido.fetch(`/users/${authenticatedUser.id}/filters`, {
		method: "DELETE"
	});
};
export default { useFilterHandler, useStickyFilterOptions };